"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shape = void 0;
var color_1 = require("../color/color");
var Shape = (function () {
    function Shape(fillColor, outlineColor, outlineWidth) {
        if (fillColor === void 0) { fillColor = color_1.ColorHelper.NO_COLOR; }
        if (outlineColor === void 0) { outlineColor = color_1.ColorHelper.NO_COLOR; }
        if (outlineWidth === void 0) { outlineWidth = 0; }
        this.fillColor = color_1.ColorHelper.NO_COLOR;
        this.outlineColor = color_1.ColorHelper.NO_COLOR;
        this.outlineWidth = 0;
        this.fillColor = fillColor;
        this.outlineColor = outlineColor;
        this.outlineWidth = outlineWidth;
    }
    Shape.prototype.clone = function () {
        return new Shape(this.fillColor, this.outlineColor, this.outlineWidth);
    };
    Shape.prototype.copyFrom = function (obj) {
        this.fillColor = obj.fillColor;
        this.outlineColor = obj.outlineColor;
        this.outlineWidth = obj.outlineWidth;
    };
    Shape.prototype.applyConverter = function (converter) {
        this.outlineWidth = converter(this.outlineWidth);
        return this;
    };
    Shape.prototype.equals = function (obj) {
        if (!obj)
            return false;
        return this.fillColor == obj.fillColor &&
            this.outlineColor == obj.outlineColor &&
            this.outlineWidth == obj.outlineWidth;
    };
    return Shape;
}());
exports.Shape = Shape;
